export class SubmissionFilters {
  sale: string;
  session: string;
  consignor: string;
  sire: string;
  dam: string;
  vet: string;
  type: string;
  status: string;
  lot: string[];

  constructor(data: any) {
    this.sale = data?.sale || '';
    this.session = data?.session || '';
    this.consignor = data?.consignor || '';
    this.sire = data?.sire || '';
    this.dam = data?.dam || '';
    this.vet = data?.vet || '';
    this.type = data?.type || '';
    this.status = data?.status || '';
    this.lot = data?.lot || [];
  }
}
